<template>
  <div
    :style="{ 'max-height': height }"
    :class="{ 'custom-scroll': true, 'custom-scroll--border-top': border_top }"
  >
    <vue-scroll ref="scroll" :size-strategy="size_strategy">
      <div class="custom-scroll__inner">
        <slot></slot>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
  export default {
    props: {
      height: {
        type: String,
        default: 'auto'
      },
      border_top: {
        type: Boolean,
        default: false
      },
      size_strategy: {
        type: String,
        default: 'number'
      }
    },

    computed: {
      ops: function() {
        return {
          vuescroll: {
            sizeStrategy: this.size_strategy,
            detectResize: true
          }
        };
      }
    },

    methods: {
      refresh() {
        this.$refs['scroll'].refresh();
      }
    }
  };
</script>

<style lang="scss">
  .custom-scroll {
    &--border-top {
      border-top: 1px solid $grey;
    }

    &__inner {
      padding-right: 20px;
    }
  }
</style>
